import ModalConfirmExit from '@/modals/modal-confirm-exit';
import PharmacyOrdersPrescription from './views/view-pharmacy-orders-prescription-new';
import PharmacyOrdersDiscount from './views/view-pharmacy-orders-discount-new';
import PharmacyOrdersDeliveryDetails from './views/view-pharmacy-orders-delivery-details-new';
import PharmacyOrdersDeliveryDetailsWeighNow from './views/program/program-view-pharmacy-orders-delivery-details-weighnow';
import Routes from '@/router/routes';

import {
  PHARMACY_ORDERS_PRESCRIPTION,
  PHARMACY_ORDERS_DISCOUNT,
  PHARMACY_ORDERS_DELIVERY_DETAILS,
  PHARMACY_WATSON_ORDERS_RX,
  PHARMACY_WATSON_ORDERS_DELIVERY_DETAILS,
  PHARMACY_WATSON_ORDERS_CALL,
  PHARMACY_ORDERS_STEP,
  PHARMACY_WATSON_ORDER_STEP,
} from '@/reference/pharmacy-order-steps';

import {
  isSaxendaProgramId,
} from '@/reference/coupon';

import {
  getPrescriptionCoupon,
} from '@/utils/medicine';

import {
  mapActions,
  mapGetters,
} from "vuex";
import {
  ACTION_RESET_PHARMACY_ORDER,
  GETTER_PRESCRIPTION_HAS_VALID_COUPON,
} from "@/store/types";
import {mapFields} from "vuex-map-fields";
import {Reference} from "smd-vue-scaffold";

export default {
  data() {
    return {
      activeStep: PHARMACY_ORDERS_PRESCRIPTION
    }
  },
  computed: {
    ...mapFields({
      attachedPrescriptions: 'attachedPrescriptions',
    }),
    ...mapGetters({
      prescriptionHasValidCoupon: GETTER_PRESCRIPTION_HAS_VALID_COUPON,
    }),
    activeComponent() {
      let deliveryDetailsFormComponent = PharmacyOrdersDeliveryDetails;

      if (this.prescriptionHasValidCoupon) {
        const {programid} = getPrescriptionCoupon(this.attachedPrescriptions[0]);

        if (isSaxendaProgramId(programid)) {
          deliveryDetailsFormComponent = PharmacyOrdersDeliveryDetailsWeighNow;
        }
      }

      const pharmacyOrdersViewMap = {
        [PHARMACY_ORDERS_PRESCRIPTION]: PharmacyOrdersPrescription,
        [PHARMACY_ORDERS_DISCOUNT]: PharmacyOrdersDiscount,
        [PHARMACY_ORDERS_DELIVERY_DETAILS]: deliveryDetailsFormComponent,
      }

      const pharmacyWatsonOrdersViewMap = {
        [PHARMACY_WATSON_ORDERS_RX]: PharmacyOrdersPrescription,
        [PHARMACY_WATSON_ORDERS_DELIVERY_DETAILS]: PharmacyOrdersDeliveryDetails,
        [PHARMACY_WATSON_ORDERS_CALL]: ''
      }

      return this.$route.name === Routes.PHARMACY_ORDERS ?
        pharmacyOrdersViewMap[this.activeStep] :
        pharmacyWatsonOrdersViewMap[this.activeStep]
    },
    computedSteps() {
      return this.$route.name === Routes.PHARMACY_ORDERS ?
        this.$options.PHARMACY_ORDERS_STEP :
        this.$options.PHARMACY_WATSON_ORDER_STEP
    }
  },
  methods: {
    ...mapActions({
      resetOrdersToDefaultState: ACTION_RESET_PHARMACY_ORDER
    }),
    goBack() {
      if (window.history.length <= 2) {
        this.$router.push({name: Routes.SERVICES_FIND_A_SERVICE_ROUTE});
      } else if (this.attachedPrescriptions.length) {
        this.$modal.open({
          component: ModalConfirmExit,
          position: 'detached auto-height',
          size: Reference.SmdModalSizes.xs,
          onClose: ({success}) => {
            if (success) {
              this.goBackToServices();
            }
          }
        })
      } else {
        this.$router.push({name: Routes.SERVICES_FIND_A_SERVICE_ROUTE});
        this.resetOrdersToDefaultState();
      }
    },
    goBackToServices() {
      this.$router.push({
        name: Routes.SERVICES_ROUTE
      })
      this.resetOrdersToDefaultState();
    },
    setActiveStep(step) {
      this.activeStep = step;
    }
  },
  PHARMACY_ORDERS_STEP,
  PHARMACY_WATSON_ORDER_STEP
}